/**
 * サイドバーを既定で開いた状態にする画面幅の下限(px)。
 * ui/Sidebar の内部既定値と、ページ側の `useSidebarOpen` が同じ値を参照するための単一ソース。
 */
export const SIDEBAR_DESKTOP_MIN_WIDTH = 1280
